	<template>
    <div>
        <!-- Overlay -->
        <a href="javascript:void(0)" class="overlay-general overlay-common"></a>
        <!-- Header Start -->
        <header class="header-common">
            <!-- Top Header -->
            <!-- <div class="top-header">
                <div class="container-lg">
                <div class="topheader-wrap">
                    <ul class="social-list">
                    <li>
                    <a class="help" href="tel:219098-874"><i data-feather="phone"></i> (219) 098-874</a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/"> <img src="/assets/icons/svg/social/fb.svg" alt="fb" /> </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/"> <img src="/assets/icons/svg/social/inta.svg" alt="instagram" /> </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/"> <img src="/assets/icons/svg/social/tw.svg" alt="tw" /></a>
                    </li>
                    <li>
                        <a href="https://youtube.com/"> <img src="/assets/icons/svg/social/youtube.svg" alt="youtube" /></a>
                    </li>
                    
                    <li>
                        <a href="https://tiktok.com/"> <img src="/assets/icons/svg/social/tiktok.svg" alt="tiktok" /> </a>
                    </li>
                    </ul>
                    
                    
                </div>
                </div>
            </div> -->
            <!-- <span> Summer sale for all swim suits - off 50%! Shop Now</span> -->
            <!-- <span ></span> -->
            <template v-if="estado_cintillo">
                <div class="top-header header-top-header" v-if="!cintillo.imagen || cintillo.active_imagen == 2"
                    :style="{ 'background-color': cintillo.color_tag + '!important' }">
                    <p class="marquee">
                        <span v-html="cintillo.description"></span>
                    </p>
                </div>
                <div class="top-header" v-if="cintillo.imagen && cintillo.active_imagen == 1"
                    :style="{ 'background-image': 'url(' + cintillo.imagen + ')', 'background-color': cintillo.color_tag + '!important' }"
                    style="background-size: 60%;background-position: center;padding: 20px;">
                </div>
            </template>

            <div class="container-lg d-none d-md-block">
                <div class="nav-wrap">
                    <!-- Navigation Start -->
                    <nav class="navigation">
                        <div class="nav-section">
                            <div class="header-section">
                                <div class="navbar navbar-expand-xl navbar-light navbar-sticky p-0">
                                    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                                        data-bs-target="#primaryMenu" aria-controls="primaryMenu">
                                        <span class="navbar-toggler-icon"></span>
                                    </button>
                                    <router-link :to="'/'" class="logo-link">
                                        <img class="logo logo-dark" src="/assets/images/logos/logo.webp" alt="logo" />
                                        <img class="logo logo-light" src="/assets/images/logos/logo-w.webp"
                                            alt="logo" />
                                    </router-link>

                                </div>
                            </div>
                        </div>
                    </nav>
                    <!-- Navigation End -->

                    <!-- Menu Right Start  -->
                    <div class="menu-right">

                        <!-- Icon Menu Start -->
                        <ul class="icon-menu">
                            <li>
                                <div class="search-bar">
                                    <div class="search">
                                        <div class="search__input-wrapper">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="feather feather-search">
                                                    <circle cx="11" cy="11" r="8"></circle>
                                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                </svg></span>

                                            <input type="text" class="search__input" name="search"
                                                v-model="search_products" @keyup.enter="toSearchFilter"
                                                @keyup="searchAutomatic()" placeholder="Buscar productos..."
                                                autocomplete="off" required>

                                            <button class="search__clear-btn" @click="clearSearch()"
                                                aria-label="Clear search input">
                                                <i class="ion-close"></i>
                                            </button>
                                            <!-- <span id="clearButton22" class="hideClearButton">X</span> -->
                                        </div>
                                        <i class="ion-ios-search search__icon"></i>
                                    </div>
                                    <div class="suggestion">
                                        <div class="suggestion__content">
                                            <div class="sugerencias" v-if="words_suggestions.length > 0">
                                                <h5>Sugerencias:</h5>
                                                <div class="flex-sugerencia">
                                                    <div class="item-sugerencia"
                                                        v-for="(product_sugge, index) in words_suggestions"
                                                        :key="index">
                                                        <a href="javascript:void(0)"
                                                            @click="selectSugg(product_sugge)">{{
                                                                product_sugge }}
                                                        </a>
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="flex-scroll"
                                                v-if="categorie_suggestions.length > 0 || product_suggestions.length > 0">
                                                <div class="suggestion__content-left-side">
                                                    <ul>
                                                        <li v-for="(categ_s, index) in categorie_suggestions"
                                                            :key="index">
                                                            <a href="javascript:void(0)" @click="selectCatgg(categ_s)">
                                                                {{ categ_s.name }}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="suggestion__content-right-side">

                                                    <template v-for="(product_sugges, index) in product_suggestions"
                                                        :key="index">
                                                        <div class="product-cart media">
                                                            <img :src="product_sugges.imagen"
                                                                class="img-fluid blur-up lazyload" alt="">
                                                            <div class="media-body"><a
                                                                    :href="'/product/' + product_sugges.slug"
                                                                    @click="searchCookie()">
                                                                    <h6>{{ product_sugges.title }}</h6>
                                                                </a>

                                                                <p class="mb-0 mt-1 price"> $ {{
                                                                    product_sugges.precio_general }} </p>
                                                            </div>
                                                        </div>
                                                    </template>


                                                    <div class="all-products">
                                                        <a :href="'/search?text=' + this.LINK_ADD">Ver todos los {{
                                                            total_products }}
                                                            productos</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="product_suggestions.length == 0 && search_products">
                                                <p>No hay productos relacionados con tu busqueda : "{{ search_products
                                                }}"</p>
                                            </div>
                                            <div class="historial" v-if="product_suggestions.length == 0">
                                                <h5>Últimas Búsquedas:</h5>
                                                <ul>
                                                    <li v-for="(search_hist, index) in search_historials" :key="index">
                                                        <img src="assets/icons/png/historial.png" alt=""> <a
                                                            href="javascript:void(0)" @click="selectSugg(search_hist)">
                                                            {{ search_hist }}
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <div class="box-mode">
                                <li class="light-icon">
                                    <a href="#" class="btnTheme" v-if="btnTheme == 1" @click="btnMode(2)"
                                        onclick="return false;" id="light-btn">
                                        <img src="/assets/images/Nuevos/mode-light.svg">
                                    </a>
                                </li>

                                <li class="dark-icon">
                                    <a href="#" class="btnTheme" v-if="btnTheme == 2" @click="btnMode(1)"
                                        onclick="return false;" id="dark-btn">
                                        <img src="/assets/images/Nuevos/mode-dark.svg">
                                    </a>
                                </li>
                            </div>

                            <!-- <li>

                            <div class="dropdown shopingbag">
                                <span class="notification-label">{{ COMPARES.length }}</span>
                            <router-link to="/comparar-producto" class="cart-button"><img src="/assets/images/Nuevos/compare-icon.webp"> </router-link>
                                <a href="javascript:void(0)" class="overlay-cart overlay-common"></a>
                                <div class="onhover-cart-dropdown">
                                    <div class="onhover-show-div text-center">
                                    <div class="dropdown-header">
                                        <div class="control">
                                            <router-link to="/comparar-producto">Comparación</router-link>
                                        <button class="back-cart"><i data-feather="arrow-right"></i></button>
                                        </div>
                                    </div>

                                    <div class="card-wrap custom-scroll">
                                        <template v-for="(WISH, index) in COMPARES" :key="index">
                                            <div class="cart-card media" >
                                                <a href="javascript:void(0)" @click="goDetailProduct(WISH)"> <img v-bind:src="WISH.imagen" class="img-fluid" alt="product" /> </a>
                                                <div class="media-body">
                                                    <a href="javascript:void(0)" @click="goDetailProduct(WISH)"> <h6>{{WISH.title}}</h6></a>
                                                    <span>$ {{WISH.precio_general}}  </span>
                                                </div>
                                                <button class="remove-cart" @click="removeCompare(WISH)"><i data-feather="x"></i></button>
                                            </div>
                                        </template>
                                    </div>
                                    <a href="#" onclick="return false;" style="display: flex;justify-content: center;align-items: center;" v-if="COMPARES.length == 0"> 
                                        <img src="/assets/images/product/zeta-notfound.svg" width="128" class="img-fluid" alt="box"> 
                                    </a>
                                    <img src="/assets/images/product/zeta-notfound.svg" v-if="COMPARES.length == 0" width="70" class="img-fluid" alt="box"> 
                                    <div class="content1" v-if="COMPARES.length == 0">
                                        <a href="#" onclick="return false;">
                                            <h6>Tu lista de comparación</h6>
                                        </a>
                                    </div>
                                    <div class="dropdown-footer" v-if="COMPARES.length > 0">
                                        <div class="freedelevery">
                                        </div>
                                        <div class="total-price">
                                        </div>
                                        <div class="btn-group block-group">
                                            <router-link to="/comparar-producto" class="btn-solid">Ver Todos</router-link>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                        </li> -->

                            <!-- <li>
                            <div class="dropdown shopingbag">
                                <span class="notification-label">{{ WISHLIST.length }}</span>
                                <router-link to="/lista-deseos" class="cart-button"><img src="/assets/images/Nuevos/favorites-icon.webp"> </router-link>
                                <a href="javascript:void(0)" class="overlay-cart overlay-common"></a>
                                <div class="onhover-cart-dropdown">
                                    <div class="onhover-show-div text-center">
                                    <div class="dropdown-header">
                                        <div class="control">
                                            <router-link to="/lista-deseos">Lista de deseo</router-link>
                                        <button class="back-cart"><i data-feather="arrow-right"></i></button>
                                        </div>
                                    </div>

                                    <div class="card-wrap custom-scroll">
                                        <template v-for="(WISH, index) in WISHLIST" :key="index">
                                            <div class="cart-card media" >
                                                <a href="javascript:void(0)" @click="goDetailProduct(WISH)"> <img v-bind:src="WISH.imagen" class="img-fluid" alt="product" /> </a>
                                                <div class="media-body">
                                                    <a href="javascript:void(0)" @click="goDetailProduct(WISH)"> <h6>{{WISH.title}}</h6></a>
                                                    <span>$ {{WISH.precio_general}}  </span>
                                                </div>
                                                <button class="remove-cart" @click="removeWish(WISH)"><i data-feather="x"></i></button>
                                            </div>
                                        </template>
                                    </div>
                                    <img src="/assets/images/product/zeta-notfound.svg" v-if="WISHLIST.length == 0" width="70" class="img-fluid" alt="box"> 
                                    <div class="content1" v-if="WISHLIST.length == 0">
                                        <a href="#" onclick="return false;">
                                            <h6>Tu lista de deseo</h6>
                                        </a>
                                    </div>
                                    
                                    <div class="dropdown-footer" v-if="WISHLIST.length > 0">
                                        <div class="freedelevery">
                                        </div>
                                        <div class="total-price">
                                        </div>
                                        <div class="btn-group block-group">
                                            <router-link to="/lista-deseos" class="btn-solid">Ver Todos</router-link>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </li> -->

                            <!-- class="user" -->
                            <li class="light-icon">
                                <div class="dropdown user-dropdown">
                                    <a href="javascript:void(0)"><img src="/assets/images/Nuevos/account.svg"></a>
                                    <ul class="onhover-show-div">

                                        <li v-if="!user"><a @click="tologin()">Iniciar sesión</a></li>
                                        <li v-if="!user"><a @click="toregister()">Registrarse</a></li>
                                        <li v-if="user"><a @click="profile()">Mi Perfil</a></li>
                                        <li v-if="user"><a @click="logout()">Salir</a></li>

                                    </ul>
                                </div>
                            </li>
                            <!-- class="user" End -->

                            <!-- Cart Menu Start -->
                       <li class="light-icon">
                            <div class="dropdown shopingbag">
                            <a href="javascript:void(0)" class="cart-button"><img src="/assets/images/Nuevos/cart-icon.webp"> <span class="notification-label">{{ CARTS.length }}</span></a>
                                <a href="javascript:void(0)" class="overlay-cart overlay-common"></a>
                                <div class="onhover-cart-dropdown">
                                    <div class="onhover-show-div text-center">
                                    <div class="dropdown-header">
                                        <div class="control">
                                        <a :href="'/cart'">Carrito de compra</a>
                                        <button class="back-cart"><i data-feather="arrow-right"></i></button>
                                        </div>
                                    </div>

                                    <div class="card-wrap custom-scroll">
                                        <template v-for="(CART, index) in CARTS" :key="CART.cart_id || CART.uniqd || CART.slug || CART.id">
                                            <div class="cart-card media" >
                                                <a href="javascript:void(0)" @click="goDetailProduct(CART)"> <img v-bind:src="CART.imagen" class="img-fluid" alt="product" /> </a>
                                                <div class="media-body">
                                                    <a href="javascript:void(0)" @click="goDetailProduct(CART)"> 
                                                        <h6>{{shortTitle(CART.title,
                                                                19) }}</h6></a>
                                                    <span>$ {{safeTotal(CART)}}  </span>
                                                    <div class="plus-minus">
                                                    <a href="javascript:void(0)" @click="minusCart(CART)"> <i class="sub" data-feather="minus"></i> </a>
                                                        <input :disabled="CART.discount>0"  type="number" :value="safeQty(CART)" min="1" max="10" />
                                                    <a href="javascript:void(0)" @click="plusCart(CART)"> <i class="add" data-feather="plus"></i> </a>
                                                    </div>
                                                </div>
                                                <button 
                                                v-if="!CART.is_pc_build && !CART.is_kit" 
                                                class="remove-cart" 
                                                :disabled="processingDel"
                                                @click.stop.prevent="enqueueDelete(CART, index)">
                                                <i data-feather="x"></i>
                                            </button>

                                                <a v-else data-bs-toggle="modal" data-bs-target="#viewCartDelete" class="remove-cart" @click.stop.prevent="removePcBuild(CART)">
                                                        <i data-feather="x"></i>
                                                    </a>
                                            </div>
                                        </template>
                                </div>

                                    <!-- <a href="#" onclick="return false;" style="display: flex;justify-content: center;align-items: center;" v-if="CARTS.length == 0"> 
                                        <img src="/assets/images/product/zeta-notfound.svg" width="128" class="img-fluid" alt="box"> 
                                    </a> -->
                                    <img src="/assets/images/product/zeta-notfound.svg" v-if="CARTS.length == 0" width="70" class="img-fluid" alt="box"> 
                                    <div class="content1" v-if="CARTS.length == 0">
                                        <a href="#" onclick="return false;">
                                            <h6>Tu carrito de compra</h6>
                                        </a>
                                    </div>

                                    <div class="dropdown-footer" v-if="CARTS.length > 0">
                                        <div class="freedelevery">
                                        <p class="terms-condition">ENVIO GRATIS! Continua comprando mas
                                             productos y 
                                             agregalos al carrito <strong>$500</strong></p>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: 70%"
                                               aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">70%
                                            </div>
                                        </div>
                                        </div>
                                        <div class="total-price">
                                        <span>Total</span>
                                        <span>$ {{ Number(TOTAL_SUM ?? 0).toFixed(2) }} </span>
                                        </div>

                                        <div class="btn-group block-group">
                                        <a  
                                        @click="goToCar()" 
                                        class="btn-solid">Ver Carrito</a>
                                        <a 
                                         @click="goToCheckout()" 
                                         class="btn-solid">Pagar</a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                            <!-- Cart Menu End -->

                        </ul>
                        <!-- Icon Menu End -->
                    </div>
                    <!-- Menu Right End  -->
                </div>
            </div>

            <div class="bg-theme-gray-light2 d-none d-sm-block">
                <div class="container-lg bottom-header">
                    <div class="nav-wrap p-0">
                        <!-- Navigation Start -->
                        <nav class="navigation">
                            <div class="nav-section">
                                <div class="header-section">
                                    <div class="navbar navbar-expand-xl navbar-light navbar-sticky p-0">

                                        <div class="offcanvas offcanvas-collapse order-lg-2" id="primaryMenu">
                                            <div class="offcanvas-header navbar-shadow">
                                                <h5 class="mt-1 mb-0">Menu</h5>
                                                <button class="btn-close lead" type="button" data-bs-dismiss="offcanvas"
                                                    aria-label="Close"></button>
                                            </div>
                                            <div class="offcanvas-body">
                                                <!-- Menu-->
                                                <ul class="navbar-nav">



                                                    <li class="nav-item">
                                                        <button class="nav-link btn-special" id="overMobile"
                                                            @click="showMegaMenu = true">Categorías</button>

                                                        <!-- <button class="nav-link btn-special" id="toggleButton">Categorías</button>

                                        <div id="accordion" style="display: none;" >
                                            
                                            <div class="accordion-item" v-for="(departament, index) in categorie_cookies" :key="index">
                                                <div class="accordion-header"> <a :href="'/shop/categorie/'+departament.id+'?text='+departament.name"
                                                    > {{ departament.name }}</a>
                                                </div>
                                                <div class="accordion-content">
                                                    <ul>
                                                    
                                                        <li class="accordion-subitem" v-for="(categorie, index2) in departament.categories" :key="index2">
                                                            <div class="accordion-subheader">
                                                                <a class="title-sub" 
                                                                    :href="'/shop/categorie/'+departament.id+'?text='+departament.name+'&categorie_second_id='+categorie.id"
                                                                > {{ categorie.name }}</a>
                                                            </div>
                                                            <div class="accordion-subcontent">
                                                                <ul>
                                                                    <li v-for="(sub_categorie, index3) in categorie.categories" :key="index3">
                                                                        <a :href="'/shop/categorie/'+departament.id+'?text='+departament.name+'&categorie_third_id='+sub_categorie.id">
                                                                            {{ sub_categorie.name }}
                                                                        </a>
                                                                    </li>
                                                                
                                                                </ul>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            
                                        </div> -->
                                                    </li>


                                                    <li class="nav-item">
                                                        <router-link class="nav-link" :to="'/discount'">
                                                            Ofertas
                                                        </router-link>
                                                    </li>

                                                    <li class="nav-item">
                                                        <router-link class="nav-link" :to="'/shop/categorie/2?text=Gamer'">
                                                            Zona
                                                            Gamer
                                                        </router-link>
                                                    </li>

                                                    <li class="nav-item">
                                                        <router-link class="nav-link" :to="'/shop/tag?text=nuevo'">
                                                        Novedades
                                                        </router-link>
                                                    </li>

                                                    <li class="nav-item">
                                                        <router-link class="nav-link"
                                                            :to="'/shop/tag?text=reingreso'">
                                                            Reingresos
                                                        </router-link>
                                                    </li>

                                                    <li class="nav-item">
                                                        <router-link class="nav-link" :to="'/shop/brands'">
                                                            Marcas
                                                        </router-link>
                                                    </li>

                                                    <li class="nav-item">
                                                        <router-link class="nav-link"
                                                            to="/shop/categorie/2?text=PC%20Gamer&categorie_third_id=639&categorie_second_id=637">Pc
                                                            Gamer</router-link>
                                                    </li>
                                                    <hr>
                                                    <div class="box-mode box-mode-mobile d-sm-block d-md-none">
                                                        <li class="light-icon">
                                                            <a href="#" class="btnTheme-mobile" v-if="btnTheme == 1"
                                                                @click="btnMode(2)" onclick="return false;"
                                                                id="light-btn-mobile">
                                                                <img src="/assets/icons/svg/sol.svg" alt=""></a>
                                                        </li>

                                                        <li class="dark-icon">
                                                            <a href="#" class="btnTheme-mobile" v-if="btnTheme == 2"
                                                                @click="btnMode(1)" onclick="return false;"
                                                                id="dark-btn-mobile">
                                                                <img src="/assets/icons/svg/luna.svg" alt="">
                                                            </a>
                                                        </li>
                                                    </div>

                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </nav>
                        <!-- Navigation End -->
                    </div>
                </div>
            </div>

            <div class=" d-block d-md-none">
                <div class="nav-wrap">
                    <!-- Navigation Start -->
                    <nav class="navigation">
                        <div class="nav-section">
                            <div class="header-section">
                                <div class="navbar navbar-expand-xl navbar-light navbar-sticky p-0">
                                    <div class="box-mode box-mode-mobile-2 d-sm-block d-md-none">
                                        <!-- <li class="dark-icon">
                                        <a href="#">
                                        <img src="/assets/icons/svg/luna.svg" alt="">
                                        </a>
                                    </li> -->
                                        <li class="light-icon" v-if="btnTheme == 1">
                                            <a href="#" class="btnTheme-mobile" @click="btnMode(2)"
                                                onclick="return false;" id="light-btn-mobile">
                                                <img src="/assets/images/Nuevos/mode-light.svg"></a>
                                        </li>

                                        <li class="dark-icon" v-if="btnTheme == 2">
                                            <a href="#" class="btnTheme-mobile" @click="btnMode(1)"
                                                onclick="return false;" id="dark-btn-mobile">
                                                <img src="/assets/images/Nuevos/mode-dark.svg">
                                            </a>
                                        </li>


                                        <!-- class="user" -->
                                        <li class="light-icon">
                                            <div class="dropdown user-dropdown">
                                                <a href="javascript:void(0)"><img
                                                        src="/assets/images/Nuevos/account.svg"></a>
                                                <ul class="onhover-show-div">

                                                    <li v-if="!user"><a @click="tologin()">Iniciar sesión</a></li>
                                                    <li v-if="!user"><a @click="toregister()">Registrarse</a></li>
                                                    <li v-if="user"><a @click="profile()">Mi Perfil</a></li>
                                                    <li v-if="user"><a @click="logout()">Salir</a></li>

                                                </ul>
                                            </div>
                                        </li>
                                        <!-- class="user" End -->

                                        <!-- Cart Menu Start -->
                                        <li class="light-icon">
                                            <div class="dropdown shopingbag">
                                                <a href="javascript:void(0) " class="cart-button"
                                                    @click="goToCar()"><img src="/assets/images/Nuevos/cart-icon.webp">
                                                    <span class="notification-label">{{ CARTS.length }}</span></a>
                                            </div>
                                        </li>
                                        <!-- Cart Menu End -->

                                        <!-- <li>
                                        <div class="dropdown whislist-dropdown" bis_skin_checked="1">
                                        <router-link to="/lista-deseos">
                                            <img src="/assets/images/Nuevos/favorites-icon.webp">
                                            <span class="notification-label">{{ WISHLIST.length }}</span>
                                        </router-link>
                                        </div>
                                    </li> -->
                                        <!-- <li>
                                        <div class="dropdown whislist-dropdown" bis_skin_checked="1">
                                        <router-link to="/comparar-producto">
                                            <img src="/assets/images/Nuevos/compare-icon.webp">
                                            <span class="notification-label">{{ COMPARES.length }}</span>
                                        </router-link>
                                        </div>
                                    </li> -->
                                    </div>
                                    <a href="/" class="logo-link">
                                        <img class="logo logo-dark" src="/assets/images/logos/logo.webp" alt="logo" />
                                        <img class="logo logo-light" src="/assets/images/logos/logo-w.webp"
                                            alt="logo" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </nav>
                    <!-- Navigation End -->
                    <!--off canvas-->
                    <div class="bg-theme-gray-light2">
                        <div class="container-lg bottom-header">
                            <div class="nav-wrap p-0">
                                <!-- Navigation Start -->
                                <nav class="navigation">
                                    <div class="nav-section">
                                        <div class="header-section">
                                            <div class="navbar navbar-expand-xl navbar-light navbar-sticky p-0">
                                                <div class="offcanvas offcanvas-collapse order-lg-2" id="primaryMenu2">
                                                    <!-- Mobile-->
                                                    <div class="offcanvas-header navbar-shadow">
                                                        <button class="btn-close lead" type="button"
                                                            data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                                    </div>
                                                    <div class="offcanvas-body">
                                                        <!-- Menu-->
                                                        <ul class="navbar-nav">
                                                            <li class="nav-item d-sm-block d-md-none">
                                                                <div id="accordion">
                                                                    <template
                                                                        v-for="(departament, index) in categorie_cookies"
                                                                        :key="index">
                                                                        <div class="accordion-item">
                                                                            <div class="accordion-header">{{
                                                                                departament.name }}</div>
                                                                            <div class="accordion-content">
                                                                                <ul>
                                                                                    <template
                                                                                        v-for="(categorie, index2) in departament.categories"
                                                                                        :key="index2">
                                                                                        <li class="accordion-subitem">
                                                                                            <div
                                                                                                class="accordion-subheader">
                                                                                                {{ categorie.name }}
                                                                                            </div>
                                                                                            <div
                                                                                                class="accordion-subcontent">
                                                                                                <ul>
                                                                                                    <template
                                                                                                        v-for="(sub_categorie, index3) in categorie.categories"
                                                                                                        :key="index3">
                                                                                                        <li><a
                                                                                                                :href="'/shop/categorie/' + departament.id + '?text=' + sub_categorie.name + '&categorie_third_id=' + sub_categorie.id + '&categorie_second_id=' + categorie.id">{{
                                                                                                                    sub_categorie.name
                                                                                                                }}</a>
                                                                                                        </li>
                                                                                                    </template>
                                                                                                    <!-- <li><a href="#">Nintendo</a></li>
                                                                                        <li><a href="#">XBOX</a></li> -->
                                                                                                </ul>
                                                                                            </div>
                                                                                        </li>

                                                                                    </template>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </template>


                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                                <!-- Navigation End -->
                            </div>
                        </div>
                    </div>
                    <!--off canvas-->
                </div>
                <div id="fixedDiv" class="fixed-res">
                    <div class=" container box-search">
                        <div class="searchBar">
                            <!-- v-model="search_products" -->
                            <input type="text" @input="event => search_products = event.target.value"
                                v-model="search_products" @keyup.enter="toSearchFilter" @keyup="searchAutomatic()"
                                class="searchBarInput" name="search" autocomplete="off"
                                placeholder="Buscar productos" />
                            <span id="clearButton" class="hideClearButton" @click="clearSearch()">X</span>
                            <div class="iconSearchContainer">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-search">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div id="res" class="results hideResults">
                            <div class="suggestion__content">
                                <!-- Lo que escribes: {{ search_products }} -->
                                <div class="sugerencias" v-if="words_suggestions.length > 0">
                                    <h5>Sugerencias:</h5>
                                    <div class="flex-sugerencia">
                                        <div class="item-sugerencia" v-for="(product_sugge, index) in words_suggestions"
                                            :key="index">
                                            <a href="javascript:void(0)" @click="selectSugg(product_sugge)">{{
                                                product_sugge }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="sugerencias"
                                    v-if="categorie_suggestions.length > 0 || product_suggestions.length > 0">
                                    <h5>Categorías:</h5>
                                    <div class="suggestion__content-left-side">
                                        <ul>
                                            <li v-for="(categ_s, index) in categorie_suggestions" :key="index">
                                                <a href="javascript:void(0)" @click="selectCatgg(categ_s)">
                                                    {{ categ_s.name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="flex-scroll"
                                    v-if="categorie_suggestions.length > 0 || product_suggestions.length > 0">
                                    <div class="suggestion__content-right-side">
                                        <template v-for="(product_sugges, index) in product_suggestions" :key="index">
                                            <div class="product-cart media">
                                                <img :src="product_sugges.imagen" class="img-fluid blur-up lazyload"
                                                    alt="">
                                                <div class="media-body"><a :href="'/product/' + product_sugges.slug"
                                                        @click="searchCookie()">
                                                        <h6>{{ product_sugges.title }}</h6>
                                                    </a>

                                                    <p class="mb-0 mt-1 price"> $ {{ product_sugges.precio_general }}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="all-products">
                                            <a :href="'/search?text=' + search_products">Ver todos los {{ total_products
                                            }} productos</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="historial" v-if="product_suggestions.length == 0">
                                    <h5>Últimas Búsquedas:</h5>
                                    <ul v-if="product_suggestions.length == 0">
                                        <li v-for="(search_hist, index) in search_historials" :key="index">
                                            <img src="assets/icons/png/historial.png" alt=""> <a
                                                href="javascript:void(0)" @click="selectSugg(search_hist)">
                                                {{ search_hist }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="menu-cintillo">
                        <ul class="navbar-nav">
                            <div>
                                <li class="nav-item">
                                    <button class="navbar-toggler nav-link btn-special" type="button"
                                        data-bs-toggle="offcanvas" data-bs-target="#primaryMenu2"
                                        aria-controls="primaryMenu2">
                                        Categorías
                                    </button>
                                </li>
                            </div>
                            <div class="menu-scroll">
                                <li class="nav-item">
                                    <a class="nav-link" href="/discount">Ofertas</a>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link" href="/shop/categorie/2?text=Gamer">Zona Gamer</a>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link" href="/shop/tag?text=nuevo">Novedades</a>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link" href="/shop/tag?text=reingreso">Reingresos</a>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link" href="/shop/brands">Marcas</a>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link" href="/search?text=pc gamer">Pc Gamer</a>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>

        </header>
        <MegaMenu v-if="showMegaMenu" :categorie_cookies="categorie_cookies" />
        <!-- <MenuMobile /> -->

        <ModalDeleteCart></ModalDeleteCart>
    </div>
</template>

<script>
// import * as rr from '../../assets/js/myjs.js'
// import mitt from 'mitt'
// const emitter = mitt()
import store from '../../plugins/store'
import myApi from '../../plugins/axios'
import CartResource from '../../resource/cart'
import WishListResource from '../../resource/wishlist'
import { debounce } from "debounce";
import Typo from 'typo-js';
// import SpanishDict from '../../assets/dictionaries/es/es.dic';
// import SpanishAff from '../../assets/dictionaries/es/es.aff';
import keywords from './keywords'
import MegaMenu from "./MegaMenu";
import ModalDeleteCart from '../../views/guest/modal/ModalDeleteCart.vue'

export default {
    name: 'HeaderSection',
    data() {
        return {
            info: null,
            CARTS: [],
            TOTAL_SUM: 0,
            WISHLIST: [],
            search_products: null,
            product_suggestions: [],
            categorie_suggestions: [],
            search_historials: [],
            groups_coupons: [],
            typo: new Typo('es', false, false, { dictionaryPath: "../../assets/dictionaries" }),
            keywords: keywords,
            words_suggestions: [],
            categ_products: null,
            busy_delete: false,
            delQueue: [],
            processingDel: false,
            // 
            showMegaMenu: false,
            COMPARES: [],
            total_products: 0,
            btnTheme: localStorage.getItem('body') == 'dark' ? 1 : 2,
            categorie_cookies: [],
            // 
            cintillo: null,
            estado_cintillo: false,
            LINK_ADD: '',
            // 
            loadingSucursal: true,
            SUB_TOTAL_SUM: 0,
            DESCUENTO_TOTAL_SUM: 0,
            CART_SELECTED: null,
            cartHydrateTimer: null,
            lastCartPayloadHash:  "",
        }
    },
    components: {
        MegaMenu,
        ModalDeleteCart,
    },
    methods: {
         async validateBeforeApply(uniqd, desiredQty) {
        const minimal = this.mergeMinimal((this.CARTS || []).map(this.toMinimal));
        const idx = minimal.findIndex(m => String(m.uniqd) === String(uniqd));
        if (idx === -1) return false;

        minimal[idx].quantity = this.clampQty(desiredQty);

        const payload = { 
            CARTS: minimal.map(m => ({ 
                uniqd: String(m.uniqd), 
                quantity: Number(m.quantity || 1) 
            })) 
        };

        try {
            const resp = await myApi.post('ecommerce/process_cart_sucursal', payload);
            return { success: true, data: resp.data };
            
        } catch (e) {
            if (e?.response?.status === 409) {
                const errorData = e?.response?.data?.error || {};
                const productos = e?.response?.data?.products || [];

                const problematicProduct = productos.find(
                    p => String(p.uniqd) === String(uniqd)
                );

                if (problematicProduct) {
                    console.log('problematica', problematicProduct)
                    const stockDisponible = Number(problematicProduct.quantity_sucursal || 0);
                   if(desiredQty > stockDisponible) {
                        this.$notify({
                            title: 'No disponible',
                            text: 'Stock insuficiente',
                            type: 'error',
                            duration: 4500,
                        });
                    } else {
                        this.$notify({
                            title: 'Límite alcanzado',
                            text: errorData || 'No se puede agregar más cantidad de este producto.',
                            type: 'error',
                            duration: 4500,
                        });
                    }
                } else {
                    this.$notify({
                        title: 'No disponible',
                        text: errorData || 'Este producto no está disponible actualmente.',
                        type: 'error',
                        duration: 4000,
                    });
                }
                
                return { success: false, error: errorData };
            }
            
            this.$notify({
                title: 'Error de validación',
                text: 'No se pudo verificar la disponibilidad del producto.',
                type: 'error',
                duration: 3500,
            });
            return { success: false, error: e };
        }
    },
limpiarEstadoUI() {
        
        document.querySelectorAll('.overlay-general, .overlay-cart, .overlay-common').forEach(el => {
            el.classList.remove('show');
        });
        
       
        document.querySelector('.side-bar')?.classList.remove('show-menu');
        document.querySelector('.sidebar-controll')?.classList.remove('show-menu');
        document.querySelector('.filter-top-wrapper')?.classList.remove('show-menu');
        
       
        document.querySelector('.search-full')?.classList.remove('open', 'show');
        document.querySelector('.shopingbag .onhover-show-div')?.classList.remove('show');
        
    
        document.querySelector('.suggestion')?.classList.remove('active');
        document.querySelector('#res')?.classList.remove('showResults');
        document.querySelector('#res')?.classList.add('hideResults');
        
     
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.classList.remove('loader-overflow');
    },
        // --- Cola de eliminaciones (secuencial) ---
        enqueueDelete(row, index) {
            // Guarda la intención de borrado aunque ya haya uno en curso
            this.delQueue.push({ row, index });
            if (!this.processingDel) this.processDeletes();
        },

        async processDeletes() {
            this.processingDel = true;
            try {
                while (this.delQueue.length) {
                    const { row, index } = this.delQueue.shift();

                    // Recalcular índice por si el array cambió
                    let i = Number.isInteger(index) && index >= 0 ? index
                        : this.CARTS.findIndex(x =>
                            String(x?.uniqd) === String(row?.uniqd) ||
                            String(x?.slug) === String(row?.slug)
                        );

                    const curr = i !== -1 ? this.CARTS[i] : row;

                    if (store.getters.loggedIn) {
                        // Asegura cart_id (usa tu helper existente)
                        const cid = await this.ensureCartIdFor(curr);
                        if (!cid) {
                            await this.hydrateCartIds();
                            if (!curr.cart_id) {
                                this.$notify({ title: 'Item no identificado', text: 'Intenta nuevamente.', type: 'error', duration: 1800 });
                                continue;
                            }
                        }

                        // Calcula el snapshot restante (sin el item)
                        // const minimalCurrent = this.mergeMinimal((this.CARTS || []).map(this.toMinimal));
                        // const remaining = minimalCurrent.filter(m => String(m.uniqd) !== String(curr.uniqd));
                         
                        // Borra en servidor (secuencial) y re-alinea todo desde BD
                        try {
                            await myApi.post(`ecommerce/carts/delete/${curr.cart_id}`, {});
                        } catch (e) {
                            console.log(e);// Si el server ya lo eliminó (404/409), igual continuamos y refrescamos
                        }

                        await this.listCarts();                          // jala BD y emite {source:'server'}
                        this.emitter?.emit?.('refres-cart-list', {});    // asegura sync con CartShop
                    } else {
                        // Invitado: remove local y emite
                        if (i !== -1) this.CARTS.splice(i, 1);
                        const minimal = this.mergeMinimal(this.CARTS.map(this.toMinimal));
                        this.writeMinimal(minimal);
                        this.emitter.emit('cart-shop', { items: minimal, replace: true, source: 'header' });
                    }

                    this.$notify({ title: 'Producto removido del carrito', type: 'error', duration: 900 });

                    // Pequeño respiro para evitar “rebotes” de la UI/feather
                    await new Promise(r => setTimeout(r, 80));
                    await this.refreshFeather();
                }
            } finally {
                this.processingDel = false;
            }
        },

        loggedRefresh() {
            if (this.$store.getters.loggedIn) {
                this.listCarts(); // ya tienes esto: jala BD y emite {source:'server'}
            }
        },
        async refreshFeather() {
            await this.$nextTick();
            if (window.feather?.replace) {
                window.feather.replace();
            }
        },



applyTheme(theme = this.btnTheme) {
  const isDark = theme === 1;             // 1 = dark, 2 = light
  document.body.classList.toggle('dark', isDark);
  document.body.classList.toggle('light', !isDark);
  localStorage.setItem('body', isDark ? 'dark' : 'light');
},
   

        async hydrateCartIds() {
  if (!store.getters.loggedIn) return;
  try {
    const resp = await myApi.get("ecommerce/carts/");
    const rows = resp?.data?.carts?.data || [];

    const by = {
      uniqd: Object.create(null),
      slug:  Object.create(null),
      pid:   Object.create(null),
      sku:   Object.create(null),
      title: Object.create(null), // normalizado
    };

    const norm = s => String(s ?? '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^\w]+/g,' ').trim();

    rows.forEach(r => {
      const id = r?.id;
      const p  = r?.product || {};
      const uniqd = String(p?.uniqd ?? r?.uniqd ?? '');
      const slug  = String(p?.slug  ?? r?.slug  ?? '');
      const pid   = String(p?.id ?? '');
      const sku   = String(p?.sku ?? p?.code ?? '');
      const title = norm(p?.title ?? r?.title ?? '');
      if (!id) return;
      if (uniqd) by.uniqd[uniqd] = id;
      if (slug)  by.slug[slug]   = id;
      if (pid)   by.pid[pid]     = id;
      if (sku)   by.sku[sku]     = id;
      if (title) by.title[title] = id;
    });

    this.CARTS.forEach(row => {
      const uniqd = String(row?.uniqd ?? '');
      const slug  = String(row?.slug  ?? '');
      const pid   = String(row?.product_id ?? row?.id_product ?? '');
      const sku   = String(row?.sku ?? row?.code ?? '');
      const title = norm(row?.title ?? '');
      row.cart_id = row.cart_id
                 || by.uniqd[uniqd]
                 || by.slug[slug]
                 || by.pid[pid]
                 || by.sku[sku]
                 || by.title[title]
                 || null;
    });
  } catch (_) { /* silencio */ }
}

        ,

        fmt(n) { const v = Number(n); return Number.isFinite(v) ? v.toFixed(2) : '0.00'; },

        // Normaliza a minimal
        toMinimal(item) { return { uniqd: String(item.uniqd), quantity: Number(item.quantity || 1) }; },
        clampQty(raw) { let q = Math.floor(Number(raw || 1)); if (!Number.isFinite(q) || q < 1) q = 1; return q; },
        mergeMinimal(list) {
            const byId = new Map();
            (Array.isArray(list) ? list : []).forEach(it => {
                if (!it || !it.uniqd) return;
                const id = String(it.uniqd);
                const qty = this.clampQty(it.quantity);
                byId.set(id, (byId.get(id) || 0) + qty);
            });
            return Array.from(byId, ([uniqd, quantity]) => ({ uniqd, quantity }));
        },
        shortTitle(text, max = 24) {
            if (!text) return '';
            const t = String(text).trim();
            if (t.length <= max) return t;
            // corta preferentemente en un espacio para no partir palabras
            const slice = t.slice(0, max);
            const lastSpace = slice.lastIndexOf(' ');
            return (lastSpace > 8 ? slice.slice(0, lastSpace) : slice) + '…';
        },

        // Lee/escribe el storage en formato minimal (ambas claves iguales por compat)
        readMinimal() {
            try {
                // const v2 = localStorage.getItem('carts_v2');
                // if (v2) {
                //     const a = JSON.parse(v2);
                //     if (Array.isArray(a)) return a.map(this.toMinimal);
                // }
                const raw = localStorage.getItem('carts');
                if (!raw) return [];
                const arr = JSON.parse(raw);
                if (!Array.isArray(arr)) return [];
                const min = arr.filter(x => x && x.uniqd).map(this.toMinimal);
                // localStorage.setItem('carts_v2', JSON.stringify(min));
                if (!store.getters.loggedIn) localStorage.setItem('carts', JSON.stringify(min));
                return min;
            } catch { return []; }
        },
        writeMinimal(min) {
            // localStorage.setItem('carts_v2', JSON.stringify(min));
            if (store.getters.loggedIn) return;
            localStorage.setItem('carts', JSON.stringify(min));
        },

        async validateQtyAndApply(uniqd, desiredQty, { silent = false } = {}) {
        const minimal = this.mergeMinimal((this.CARTS || []).map(this.toMinimal));
        const idx = minimal.findIndex(m => String(m.uniqd) === String(uniqd));
        if (idx === -1) return;

        minimal[idx].quantity = this.clampQty(desiredQty);

        const { items } = await this.hydrateFromMinimal(minimal);

        const byId = Object.fromEntries(items.map(i => [String(i.uniqd), i]));
        this.CARTS = this.CARTS.map(row => {
            const upd = byId[String(row.uniqd)];
            return upd ? {
                ...row,
                quantity: upd.quantity,
                max_stock: (upd.max_stock ?? row.max_stock ?? null),
                price_unit: upd.price_unit ?? row.price_unit,
                subtotal: upd.subtotal ?? row.subtotal,
                total: upd.total ?? row.total,
            } : row;
        });

        const MIN = this.mergeMinimal(items.map(this.toMinimal));
        if (store.getters.loggedIn) {
            try { 
                await myApi.post('ecommerce/update_cart', { cart: MIN }); 
            } catch { 
                console.error('Error al persistir cantidades'); 
            }
            await this.listCarts();
        } else {
            this.writeMinimal(MIN);
            this.emitter.emit('cart-shop', { items: MIN, replace: true, source: 'header' });
        }

        const applied = byId[String(uniqd)]?.quantity ?? minimal[idx].quantity;
        const requested = this.clampQty(desiredQty);
        if (applied < requested && !silent) {
            this.$notify({
                title: 'Ajustamos cantidades al stock disponible',
                duration: 4500,
                type: 'warn',
            });
        }
    },

        // Hidrata una lista minimal con el back para obtener precios, descuentos y meta
        async hydrateFromMinimal(minimal) {
            if (!Array.isArray(minimal) || minimal.length === 0) {
                return { items: [], total: 0 };
            }

            const payload = { CARTS: minimal.map(m => ({ uniqd: String(m.uniqd), quantity: this.clampQty(m.quantity) })) };

            // Soporta 200 y 409
            let data = null;
            try {
                const resp = await myApi.post('ecommerce/process_cart_sucursal', payload);
                data = resp?.data || {};
            } catch (e) {
                if (e?.response?.status === 409) {
                    data = e.response.data || {};
                } else {
                    // Falla silenciosa (no rompas el header)
                    data = {};
                }
            }

            const precios = data.precios || data.prrecios || [];
            const meta = data.meta || [];

            const byPrice = Object.fromEntries(precios.map(p => [String(p.uniqd), p]));
            const byMeta = Object.fromEntries(meta.map(m => [String(m.uniqd), m]));

            // Si hay 409 y vino "products" con quantity_sucursal, clamp cantidades
            const outs = Array.isArray(data.products) ? data.products : [];
            const maxById = Object.fromEntries(outs.map(o => [String(o.uniqd), Number(o.quantity_sucursal || 0)]));

            const items = minimal.map(m => {
                const pid = String(m.uniqd);
                const p = byPrice[pid] || {};
                const md = byMeta[pid] || {};

                const maxAllowed = maxById[pid];                 // puede venir vacío si 200
                const requested = this.clampQty(m.quantity);
                const clamped = Number.isFinite(maxAllowed) ? Math.max(1, Math.min(requested, maxAllowed)) : requested;

                const price = Number(p.precio ?? p.price ?? 0);
                const d = p.descuento ?? p.descuneto ?? null;
                const percentage = Number(d?.percentage ?? 0);
                const unit = Number(d?.new_amount ?? price);

                return {
                    uniqd: pid,
                    quantity: clamped,
                    max_stock: Number.isFinite(maxAllowed) ? maxAllowed : null,  // 👈 guarda el tope si vino
                    title: md.title || '',
                    slug: md.slug || '',
                    imagen: md.imagen || md.image_url || '/assets/images/placeholder-product.png',
                    price_unit: Number.isFinite(price) ? price : 0,
                    subtotal: Number.isFinite(unit) ? unit : 0,
                    total: (Number.isFinite(unit) ? unit : 0) * clamped,
                    type_discount: d ? 1 : 0,
                    type_discount_old: d ? 1 : 0,
                    discount: percentage,
                    discount_old: percentage,
                    code_discount: d?.code ?? 0,
                    code_offer: d?.code ?? 0,
                };
            });

            const total = items.reduce((s, x) => s + Number(x.total || 0), 0);

            // 🔑 Si el user está logeado, hidrata cart_id para permitir delete desde header
            if (store.getters.loggedIn) {
                try {
                    const resp = await myApi.get("ecommerce/carts/");
                    const rows = resp?.data?.carts?.data || [];
                    const mapIds = Object.fromEntries(rows.map(r => [String(r.product?.uniqd || r.uniqd), r.id]));
                    items.forEach(row => { const id = mapIds[String(row.uniqd)]; if (id) row.cart_id = id; });
                } catch { /* silent */ }
            }

            return { items, total };
        },
        safeTotal(C) {
            // Muestra un total estable: usa C.total si es válido; si no, calcula con unitario*qty;
            // y si tampoco, usa un caché en localStorage para evitar el “0” fugaz.
            try {
                const key = String(C?.uniqd ?? C?.slug ?? C?.id ?? '');
                const qty = Number(C?.quantity ?? 0);
                const t = Number(C?.total);
                const u1 = Number(C?.subtotal);   // unitario efectivo (con descuento)
                const u0 = Number(C?.price_unit); // unitario base

                // lee caché
                const cacheRaw = localStorage.getItem('carts_item_cache') || '{}';
                const cache = JSON.parse(cacheRaw);

                let computed;
                if (Number.isFinite(t) && t > 0) {
                    computed = t;
                } else if (Number.isFinite(u1) && u1 > 0 && qty > 0) {
                    computed = u1 * qty;
                } else if (Number.isFinite(u0) && u0 > 0 && qty > 0) {
                    computed = u0 * qty;
                } else if (key && cache[key] && Number(cache[key].total) > 0) {
                    computed = Number(cache[key].total);
                } else {
                    computed = 0;
                }

                // actualiza caché cuando haya un valor útil (>0)
                if (key && computed > 0) {
                    cache[key] = {
                        total: computed,
                        qty: (Number.isFinite(qty) && qty > 0) ? qty : (cache[key]?.qty || 1)
                    };
                    localStorage.setItem('carts_item_cache', JSON.stringify(cache));
                }

                return Number(computed || 0).toFixed(2);
            } catch (e) {
                return Number(C?.total || 0).toFixed(2);
            }
        },

        safeQty(C) {
            // Muestra cantidad estable: usa C.quantity si es válida; si no, caché.
            try {
                const key = String(C?.uniqd ?? C?.slug ?? C?.id ?? '');
                const q = Number(C?.quantity);

                const cacheRaw = localStorage.getItem('carts_item_cache') || '{}';
                const cache = JSON.parse(cacheRaw);

                let qty;
                if (Number.isFinite(q) && q > 0) {
                    qty = q;
                } else if (key && cache[key] && Number(cache[key].qty) > 0) {
                    qty = Number(cache[key].qty);
                } else {
                    qty = 1;
                }

                // si viene válida, guarda
                if (key && Number.isFinite(q) && q > 0) {
                    cache[key] = { ...(cache[key] || {}), qty: q };
                    localStorage.setItem('carts_item_cache', JSON.stringify(cache));
                }

                return qty;
            } catch (e) {
                return Number(C?.quantity || 1);
            }
        },


        async hydrateMiniCart(minimalOverride = null) {
            const minimal = (Array.isArray(minimalOverride) && minimalOverride.length)
                ? minimalOverride.map(this.toMinimal)
                : this.readMinimal();

            const { items, total } = await this.hydrateFromMinimal(minimal);
            this.CARTS = items;
            this.TOTAL_SUM = total;

            if (store.getters.loggedIn) await this.hydrateCartIds();

            // 👇 asegura que los íconos +/- y X aparezcan
            this.refreshFeather();
        },



        markUrl() {
            let LINK_CATEG = this.categ_products ? this.categ_products : '';
            if (LINK_CATEG) {
                if (LINK_CATEG.level == 2) {
                    LINK_CATEG = "&categorie_second_id=" + LINK_CATEG.id
                }
                if (LINK_CATEG.level == 3) {
                    LINK_CATEG = "&categorie_third_id=" + LINK_CATEG.id
                }
            }
            this.LINK_ADD = this.search_products + LINK_CATEG;
        },
       btnMode(val) {
          this.btnTheme = val;
          const isDark = val === 1;
          const html = document.querySelector("html");
          const darkLink = document.querySelector("#change-link");
            
          if (isDark) {
              html.className = "dark";
              if (darkLink) darkLink.href = "/assets/css/dark.css";
              localStorage.setItem("body", "dark");
          } else {
              html.className = "";
              if (darkLink) darkLink.href = "/assets/css/style.css";
              localStorage.setItem("body", "light");
          }
          
          setTimeout(() => {
              this.emitter.emit('dark-ligth', {});
          }, 50);
},
        goToCar() {
            this.$router.push({
                name: 'CartShop',
            })
        },
        goToCheckout() {
            this.$router.push({
                name: 'Checkout',
            })
        },
        tohome() {
            this.$router.push({
                name: 'Home',
            })
        },
        toregister() {
            this.$router.push({
                name: 'Register',
            })
        },
        tologin() {
            this.$router.push({
                name: 'Login',
            })
        },
 async logout() {
            localStorage.removeItem('carts');
            localStorage.removeItem('carts_item_cache');
            this.CARTS = [];
            this.TOTAL_SUM = 0;
            await  store.dispatch('logout');
             await this.$router.replace('/')
            window.location.reload()
            // this.$router.push('/')
            // setTimeout(() => {
            //     this.$router.push({
            //         name: 'Home',
            //     })
            // }, 50);

        },
        profile() {
            setTimeout(() => {
                this.$router.push({
                    name: 'ProfileClient',
                })
            }, 50);
        },
        goDetailProduct(CART) {
            this.$router.push({
                name: 'DetailProduct',
                params: {
                    slug: CART.slug,
                }
            })
            setTimeout(() => {
                location.reload();
            }, 50);
        },
        removePcBuild(CART) {
            this.CART_SELECTED = CART;
            CART.is_header_nav = true;
            this.emitter.emit("open-delete-cart", CART);
        },
async plusCart(CART) {
        const idx = this.CARTS.findIndex(p => String(p.uniqd) === String(CART.uniqd));
        if (idx === -1) return;

        const row = this.CARTS[idx];
        const curr = Math.max(1, Number(row.quantity || 1));
        const next = curr + 1;

      
        const validation = await this.validateBeforeApply(CART.uniqd, next);
    
        if (!validation.success) {
            return;
        }

     
     
        await this.validateQtyAndApply(CART.uniqd, next, { silent: true });
    },

   
    async minusCart(CART) {
        const idx = this.CARTS.findIndex(p => String(p.uniqd) === String(CART.uniqd));
        if (idx === -1) return;

        const row = this.CARTS[idx];
        const curr = Math.max(1, Number(row.quantity || 1));
        const next = curr - 1;

        if (next < 1) {
            this.$notify({ 
                title: 'Cantidad de producto no válida', 
                type: 'error', 
                duration: 3000 
            });
            return;
        }

       
        const validation = await this.validateBeforeApply(CART.uniqd, next);
        
        if (!validation.success) {
            return;
        }

        await this.validateQtyAndApply(CART.uniqd, next, { silent: true });
    },



        async deleteCart(data, index) {
            if (this.busy_delete) return;
            this.busy_delete = true;
            try {
                if (!Number.isInteger(index) || index < 0) {
                    index = this.CARTS.findIndex(x =>
                        String(x?.uniqd) === String(data?.uniqd) ||
                        String(x?.slug) === String(data?.slug)
                    );
                }

                if (store.getters.loggedIn) {
                    const cid = await this.ensureCartIdFor(data);
                    if (!cid) {
                        await this.hydrateCartIds();
                        if (!data.cart_id) {

                            this.$notify({ title: 'Item no identificado', text: 'Intenta nuevamente.', type: 'error', duration: 2500 });
                            return;

                        }
                    }

                    const minimalCurrent = this.mergeMinimal((this.CARTS || []).map(this.toMinimal));
                    const remaining = minimalCurrent.filter(m => String(m.uniqd) !== String(data.uniqd));

                    await myApi.post(`ecommerce/carts/delete/${data.cart_id}`, { CARTS: remaining });
                    await this.listCarts();
                    if ((this.CARTS || []).length === 0 && remaining.length > 0) {
                        await new Promise(r => setTimeout(r, 150));
                        await this.listCarts();
                    }

                    this.$notify({ title: 'Producto removido del carrito', type: 'error', duration: 1000 });
                    return;
                }

                // Invitado
                if (index !== -1) this.CARTS.splice(index, 1);
                const minimal = this.mergeMinimal(this.CARTS.map(this.toMinimal));
                this.writeMinimal(minimal);
                this.emitter.emit('cart-shop', { items: minimal, replace: true, source: 'header' });
                this.$notify({ title: 'Producto removido del carrito', type: 'error', duration: 1000 });

            } catch (e) {
                this.$notify({ title: 'Error al eliminar', type: 'error', duration: 2000 });
                if (process.env.NODE_ENV !== 'production') console.warn('deleteCart error', e);
            } finally {
                this.busy_delete = false;
            }
        },





async mergeGuestCartIntoAccount(minimal = null) {
  try {
    const src = Array.isArray(minimal) ? minimal : this.readMinimal();
    if (!src || src.length === 0) return;

    // crea las líneas en el server
    await Promise.allSettled(
      src.map(m => myApi.post("ecommerce/carts/", {
        uniqd: String(m.uniqd),
        quantity: this.clampQty(m.quantity)
      }))
    );

    // refresca desde el server (ahora con cart_id)
    await this.listCarts();
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.warn('mergeGuestCartIntoAccount error', e);
  }
}
,

        async ensureCartIdFor(row) {
            if (row?.cart_id) return row.cart_id;

            // 1) intenta hidratar todos
            await this.hydrateCartIds();
            if (row.cart_id) return row.cart_id;

            // 2) último recurso: vuelve a leer del servidor y mapear
            try {
                const resp = await myApi.get("ecommerce/carts/");
                const rows = resp?.data?.carts?.data || [];
                const found = rows.find(r =>
                    String(r?.product?.uniqd ?? r?.uniqd) === String(row?.uniqd) ||
                    String(r?.product?.slug ?? r?.slug) === String(row?.slug)
                );
                if (found?.id) {
                    row.cart_id = found.id;
                    return row.cart_id;
                }
            } catch (e) {
                if (process.env.NODE_ENV !== 'production') console.warn('ensureCartIdFor error', e);
            }
            return null;
        }
        ,




        removeCart(CART) {
            const idx = this.CARTS.findIndex(p => String(p.uniqd) === String(CART.uniqd));
            if (!store.getters.loggedIn) {
                if (idx !== -1) this.CARTS.splice(idx, 1);
                const minimal = this.CARTS.map(this.toMinimal);
                this.writeMinimal(minimal);
                this.emitter.emit('cart-shop', { items: minimal, replace: true, source: 'header' });
                this.$notify({ title: "Producto removido del carrito", type: 'error', duration: 3500 });
            } else {
                if (idx !== -1) this.deleteCart(this.CARTS[idx], idx);
            }
        },


        // removeCart(CART){
        //     // let CARTS = this.$cookies.get("carts") ? this.$cookies.get("carts") : [];
        //     let INDEX = this.CARTS.findIndex(product => product.uniqd == CART.uniqd);


        //     if(!store.getters.loggedIn){
        //         if(INDEX != -1){
        //             this.CARTS.splice(INDEX,1);
        //         }
        //         // this.$cookies.set('carts',this.CARTS);
        //         localStorage.setItem('carts',JSON.stringify(this.CARTS));
        //         this.$notify({
        //             title: "Producto removido del carrito",
        //             // text: `El producto '${CART.title}' se elimino del carrito correctamente!`,
        //             type: 'error',
        //             duration: 2000,
        //         });
        //     }else{
        //         if(INDEX != -1){
        //             this.deleteCart(this.CARTS[INDEX],INDEX);
        //         }
        //     }
        //     this.emitter.emit('cart-shop', this.CARTS);
        // },
        removeWish(WISH) {
            let INDEX = this.WISHLIST.findIndex(product => product.uniqd == WISH.uniqd);

            // if(INDEX != -1){
            //   this.WISHLIST.splice(INDEX,1);
            // }

            // this.$cookies.set('wishlist',this.WISHLIST);
            if (!store.getters.loggedIn) {
                if (INDEX != -1) {
                    this.WISHLIST.splice(INDEX, 1);
                }
                this.$cookies.set('wishlist', this.WISHLIST);
                this.$notify({
                    title: "Producto removido de lista de deseos",
                    // text: `Tu producto '${WISH.title}' se elimino de la lista de deseo!`,
                    duration: 2000,
                    type: 'error'
                });
            } else {
                if (INDEX != -1) {
                    this.deleteWish(this.WISHLIST[INDEX], INDEX);
                }
            }
            this.emitter.emit('wish-list-product', this.WISHLIST);

            // this.$notify({
            //     title: "LISTA DE DESEOS",
            //     text: `TU PRODUCTO '${WISH.title}' SE ELIMINO DE LA LISTA DE DESEO!`,
            //     duration: 1000,
            //     type:'warn'
            // });
        },
        removeCompare(COMPARE) {
            let INDEX = this.COMPARES.findIndex(product => product.uniqd == COMPARE.uniqd);

            if (INDEX != -1) {
                this.COMPARES.splice(INDEX, 1);
            }

            // this.$cookies.set('compares',this.COMPARES);
            localStorage.setItem('compares', this.COMPARES);
            this.emitter.emit('compare-product', this.COMPARES);

            this.$notify({
                // title: "COMPARACIÓN DE PRODUCTOS",
                // text: `TU PRODUCTO '${COMPARE.title}' SE ELIMINO DE LA LISTA DE COMPARACIÓN!`,
                title: "Producto removido de comparar",
                // text: `Tu producto '${COMPARE.title}' se elimino de la lista de comparación!`,
                duration: 4000,
                type: 'error'
            });
        },
  async listCarts() {
    try {
        const resp = await myApi.get("ecommerce/carts/");
        let CARTS = [];
        (resp?.data?.carts?.data || []).forEach(cart => {
            CARTS.push(CartResource.update(cart));
        });
        this.CARTS = CARTS;
   // 🔄 Completar precios/totales si el server los trae vacíos

        const MIN = CARTS.map(c => ({ 
            uniqd: String(c.uniqd), 
            quantity: Number(c.quantity || 1) 
        }));

        try {
            const { items } = await this.hydrateFromMinimal(MIN);
            const by = Object.fromEntries(items.map(i => [String(i.uniqd), i]));
   
            this.CARTS = this.CARTS.map(r => {
                const p = by[String(r.uniqd)];
                return p ? {
                    ...r,
                    price_unit: (p.price_unit ?? r.price_unit),
                    subtotal:   (p.subtotal   ?? r.subtotal),
                    total:      (p.total      ?? r.total),
                    imagen:     r.imagen || p.imagen,
                    title:      r.title  || p.title,
                    slug:       r.slug   || p.slug,
                } : r;
            });
        } catch { /* silent */ }

        // 👉 TOTAL y emisión como 'server'
        this.TOTAL_SUM = 
        //(this.CARTS || []).
       ( this.CARTS = Array.isArray(this.CARTS) ? this.CARTS : [this.CARTS]).
        reduce((s, x) => s + Number(x.total || 0), 0);
        const snapshot = this.CARTS.map(c => ({ 
            uniqd: String(c.uniqd), 
            quantity: Number(c.quantity || 1) 
        }));

        this.emitter.emit('cart-shop', { 
            items: snapshot, 
            replace: true, 
            source: 'server' 
        });

         // 👉 Feather icons visibles después de pintar
    await this.refreshFeather();

        // grupos de cupones
        this.groups_coupons = resp.data.groups_coupons || [];
        this.emitter.emit("groups_coupons", this.groups_coupons);
        await this.refreshFeather();
    } catch (e) {
        console.error(e);
        
    }
},

        async updateCarts(carts) {
            let data = {
                CARTS: carts,
            }
            try {
                const resp = await myApi.post('ecommerce/update_carts', data);
                this.emitter.emit("cart-shop", resp.data.CARTS);
                this.$notify({
                    title: "CUPON",
                    text: `TU LISTA DE CARRITO SE ACTUALIZO CORRECTAMENTE , ELIMINANDO AL CUPON SELECCIONADO`,
                    duration: 2000,
                });
            } catch (error) {
                this.$notify({
                    title: "VALIDACIÓN",
                    text: "HUBO UN ERROR A NIVEL INTERNO, PORFAVOR COMUNICARSE CON SU PROVEEDOR",
                    duration: 2000,
                    type: 'error',
                });
            }
        },
 // ✅ POST /ecommerce/carts y luego ALINEA TODO DESDE SERVER (o desde resp.carts)
//    Además: NO hace notify aquí para evitar doble toast (el de CartResource.add ya avisa).
async addCart(data) {
    
    try {
        // hard-guard de cantidad
        const CART_EDIT_Q = data.qty_old;
        if (CART_EDIT_Q && data.quantity < 1) return;

        // 1) Postear SIEMPRE payload mínimo (el back ya resuelve product_id desde uniqd)
        const resp = await myApi.post("ecommerce/carts/", {
            uniqd:    String(data.uniqd || ''),
            quantity: Number(data.quantity || 1),
            is_kit:       data.is_kit ? 1 : 0,
            is_pc_build:  data.is_pc_build ? 1 : 0,
        });

        // 2) Preferir la colección que ya viene en la respuesta (como prod)
        const rows = resp?.data?.carts?.data || [];

        if (Array.isArray(rows) && rows.length) {
            let CARTS = rows.map(cart => CartResource.update(cart));
            this.CARTS = CARTS;

            const MIN = CARTS.map(c => ({ 
                uniqd: String(c.uniqd), 
                quantity: Number(c.quantity || 1) 
            }));

      // Hidrata precios/meta desde process_cart_sucursal (por si la DB aún no guarda totales)
            try {
                const { items } = await this.hydrateFromMinimal(MIN);
                const by = Object.fromEntries(items.map(i => [String(i.uniqd), i]));
                this.CARTS = this.CARTS.map(r => {
                    const p = by[String(r.uniqd)];
                    return p ? {
                        ...r,
                        price_unit: (p.price_unit ?? r.price_unit),
                        subtotal:   (p.subtotal   ?? r.subtotal),
                        total:      (p.total      ?? r.total),
                        imagen:     r.imagen || p.imagen,
                        title:      r.title  || p.title,
                        slug:       r.slug   || p.slug,
                    } : r;
                });
            } catch { return[] }

          
            this.emitter.emit('cart-shop', { 
                items: MIN, 
                replace: true, 
                source: 'server' 
            });

            this.TOTAL_SUM = (this.CARTS || []).reduce((s, x) => s + Number(x.total || 0), 0);
            await this.refreshFeather();

            return;
        }

        await this.listCarts();

    } catch (error) {
        if (process.env.NODE_ENV !== 'production') console.log(error);
    }
},
        // async deleteCart(data,index){
        //     try {
        //         const resp = await myApi.delete(
        //             "ecommerce/carts/"+data.cart_id
        //         );
        //         console.log(resp);
        //         if(index != -1){
        //             this.CARTS.splice(index,1);
        //         }
        //         this.$notify({
        //             title: "Producto removido del carrito",
        //             // text: `Tu producto '${data.title}' se elimino del carrito!`,
        //             type: 'error',
        //             duration: 2000,
        //         });
        //     } catch (error) {
        //         console.log(error);
        //     }
        // },
        async listWishList() {
            try {
                const resp = await myApi.get(
                    "ecommerce/wishlists/"
                );
                let WISHLIST = [];
                resp.data.wishlists.forEach(wish => {
                    WISHLIST.push(WishListResource.update(wish));
                });
                this.emitter.emit("wish-list-product", WISHLIST);
            } catch (error) {
                console.log(error);
            }
        },
        async addWishList(data) {
            try {
                const resp = await myApi.post(
                    "ecommerce/wishlists/", data
                );
                let INDEX = this.WISHLIST.findIndex(product => product.uniqd == data.uniqd);
                if (INDEX != -1) {
                    this.WISHLIST[INDEX] = WishListResource.update(resp.data.wishlist);
                } else {
                    this.WISHLIST.push(WishListResource.update(resp.data.wishlist))
                }
                this.emitter.emit("wish-list-product", this.WISHLIST);
                this.$notify({
                    title: "Producto agregado a lista de deseos",
                    // text: `Tu producto '${resp.data.wishlist.product.title}' se agrego a lista de deseo!`,
                    duration: 4000,
                    type: 'success',
                });
            } catch (error) {
                console.log(error);
            }
        },
        
        async deleteWish(data, index) {
            try {
                await myApi.delete(
                    "ecommerce/wishlists/" + data.id
                );
                if (index != -1) {
                    this.WISHLIST.splice(index, 1);
                }
                this.$notify({
                    title: "Producto removido de lista de deseos",
                    // text: `Tu producto '${data.title}' se elimino de la lista de deseo!`,
                    duration: 4000,
                    type: 'error',
                });
            } catch (error) {
                console.log(error);
            }
        },
        searchCookie() {
            let SEARCHLIST = this.$cookies.get("searchlist") ? this.$cookies.get("searchlist") : [];
            SEARCHLIST.unshift(this.search_products);
            if (SEARCHLIST.length > 9) {
                SEARCHLIST.pop();
            }
            this.$cookies.set("searchlist", SEARCHLIST);
        },
        selectSugg(product_sugge) {
            this.search_products = product_sugge;
            this.searchAutomatic();
        },
        selectCatgg(categ_s) {
            this.categ_products = categ_s;
            this.querySearch(this.search_products);
        },
        toSearchFilter() {
            this.searchCookie();
            // if(this.words_suggestions.length > 0){
            //     this.search_products = this.words_suggestions[0];
            // }
            window.location.href = "/search?text=" + this.search_products;
        },
        async querySearch(suggest_words = null) {
            try {
                const resp = await myApi.post(
                    "ecommerce/search_products/", {
                    search: suggest_words ? suggest_words : this.search_products,
                    categ_products: this.categ_products,
                }
                );
                this.markUrl();

                this.total_products = resp.data.total_products;
                this.product_suggestions = resp.data.products;
                this.categorie_suggestions = resp.data.categories;
                setTimeout(() => {
                    this.categ_products = null;
                    const script2 = document.createElement('script');
                    script2.src = '../../assets/js/feather/feather.min.js';
                    document.body.appendChild(script2);
                    script2.onload = () => {
                        // console.log('archivo.js cargado 2');
                    }
                }, 50);
            } catch (error) {
                console.log(error);
                this.$notify({
                    title: "SERVIDOR",
                    text: `PRESENTAMOS PROBLEMA EN EL SERVIDOR , COMUNICARSE CON EL PROVEEDOR DE LA WEB`,
                    duration: 1000,
                });
            }
        },
        searchAutomatic: debounce(async function () {
            try {
                // this.search_historials = this.$cookies.get("searchlist") ? this.$cookies.get("searchlist") : [];
                // this.corrections = this.typo.check(this.inputText);
                // this.search_products = this.search_products;
                if (this.search_products && this.search_products.length > 1) {
                    if (!this.isMobile()) {
                        this.words_suggestions = this.keywords.keywords().filter(item => item.indexOf(this.search_products) != -1);
                        if (this.words_suggestions.length == 0 && this.search_products.length < 12) {
                            const correcciones = this.typo.suggest(this.search_products);
                            this.words_suggestions = correcciones;
                            // if(correcciones.length == 0){
                            //     this.querySearch(this.search_products);
                            // }else{
                            //     this.querySearch(this.words_suggestions[0]);
                            // }
                            this.querySearch(this.search_products);
                        } else {
                            if (this.search_products.length >= 12) {
                                this.querySearch(this.search_products);
                            } else {
                                this.querySearch(this.words_suggestions[0]);
                            }
                        }
                    } else {
                        this.querySearch(this.search_products);
                    }
                } else {
                    this.words_suggestions = [];
                    this.product_suggestions = [];
                    this.categorie_suggestions = [];
                    this.total_products = 0;
                }
                // console.log(this.typo.check(this.search_products));
            } catch (error) {
                console.log(error);
            }
        }, 250),
        async getDepartaments() {
            try {
                const resp = await myApi.get(
                    "ecommerce/departaments/");


                this.categorie_cookies = resp.data.categorias;
                setTimeout(() => {
                    // this.$cookies.set('categories_add',);
                    var script578 = document.createElement('script');
                    script578.src = '../../assets/js/myjs/submenumobile.js';
                    document.body.appendChild(script578);
                    script578.onload = () => {
                        // console.log('archivo.js cargado 56');
                    }
                    localStorage.setItem("departaments", JSON.stringify(this.categorie_cookies));
                }, 50);
            } catch (error) {
                console.log(error);
                this.$notify({
                    title: "SERVIDOR",
                    text: `PRESENTAMOS PROBLEMA EN EL SERVIDOR , COMUNICARSE CON EL PROVEEDOR DE LA WEB`,
                    duration: 1000,
                });
            }
        },
        initDepartaments() {
            let CATEGORIES = localStorage.getItem("departaments") ? JSON.parse(localStorage.getItem("departaments")) : [];
            if (CATEGORIES.length == 0) {
                this.getDepartaments()
            } else {
                this.categorie_cookies = CATEGORIES;
                setTimeout(() => {
                    var script578 = document.createElement('script');
                    script578.src = '../../assets/js/myjs/submenumobile.js';
                    document.body.appendChild(script578);
                    script578.onload = () => {
                        // console.log('archivo.js cargado 56');
                    }
                }, 50);
            }
        },
        clearSearch() {
            this.search_products = null;
            this.searchAutomatic();
        },
        isMobile() {
            if (window.innerWidth <= 767 || screen.width <= 767) {
                return true;
            }
            else {
                return false;
            }
        },
    },
    computed: {
        user() {
            return store.state.user;
        },
    },
    beforeUnmount() {
        this.emitter.off("hide-mega-menu");
        this.emitter.off("hide-mega-menu");
        this.emitter.off("acept-terminos-header");
        this.emitter.off("cart-shop");
        this.emitter.off("save-cart");
        this.emitter.off("cart-list");
        this.emitter.off("refres-cart-list");
        this.emitter.off("wish-list-product");
        this.emitter.off("save-wish-list");
        this.emitter.off("compare-product");
    },
    created() {
        // this.typo = new Typo('es', false, false, { dictionaryPath: "../../assets/dictionaries" });
        this.initDepartaments()
    },
    mounted: async function () {
    // 1) Cintillo / config inicial
    try {
        const resp = await myApi.post('ecommerce/config_all', {});
        this.cintillo = resp.data.cintillo;
        this.estado_cintillo = resp.data.cintillo.state;
    } catch (e) { /* silencioso */ }

    // 2) Estado inicial según sesión
    if (!store.getters.loggedIn) {
        await this.hydrateMiniCart();
    } else {

        await this.listCarts();
        try { 
            if (!store.getters.loggedIn) localStorage.setItem('carts', '[]');
        } catch(e) { console.log(e); }
    }

    this.emitter.on("hide-mega-menu", () => {
        this.showMegaMenu = false;
    });

    this.emitter.on('acept-terminos-header', () => {
        this.removeCart(this.CART_SELECTED);
    });

    this.emitter.on('cart-shop', async (payload) => {
        const isObj = payload && typeof payload === 'object' && !Array.isArray(payload);
        const source = isObj ? payload.source : null;

        // Ignora ecos desde el propio header
        // if (source === 'header') return;

        if (store.getters.loggedIn) {
            if (source === 'server') {
            
                await this.refreshFeather();
                this.TOTAL_SUM = (this.CARTS || []).reduce((s, x) => s + Number(x.total || 0), 0);
                return;
            }
            
            if (source === 'cart') {
                const items = isObj ? (payload.items || []) : (Array.isArray(payload) ? payload : []);
                const minimal = (items || [])
                    .filter(x => x && x.uniqd)
                    .map(x => ({ uniqd: String(x.uniqd), quantity: Number(x.quantity || 1) }));

                const qtyMap = Object.fromEntries(minimal.map(m => [String(m.uniqd), Number(m.quantity || 1)]));
                this.CARTS = this.CARTS.filter(row => qtyMap[String(row.uniqd)]); // elimina los que ya no están
                this.CARTS.forEach(row => {
                    const q = qtyMap[String(row.uniqd)];
                    if (typeof q === 'number' && q > 0) {
                        row.quantity = q;
                        const unit = Number(row.subtotal) || Number(row.price_unit) || 0;
                        row.total = unit * q;
                    }
                });

                this.TOTAL_SUM = this.CARTS.reduce((s, x) => s + Number(x.total || 0), 0);

              
                
                return;
            }

           
            return;
        }

       
        const items = isObj ? (payload.items || []) : (Array.isArray(payload) ? payload : []);
        const minimal = (items || [])
            .filter(x => x && x.uniqd)
            .map(x => ({ uniqd: String(x.uniqd), quantity: Number(x.quantity || 1) }));

        
        const qtyMap = Object.fromEntries(minimal.map(m => [String(m.uniqd), Number(m.quantity || 1)]));
        
       
        const existingIds = new Set(minimal.map(m => String(m.uniqd)));
        this.CARTS = this.CARTS.filter(row => existingIds.has(String(row.uniqd)));
        
        this.CARTS.forEach(row => {
            const q = qtyMap[String(row.uniqd)];
            if (typeof q === 'number' && q > 0) {
                row.quantity = q;
                // Recalcula total del ítem
                const unit = Number(row.subtotal) || Number(row.price_unit) || 0;
                row.total = unit * q;
            }
        });
        
        this.TOTAL_SUM = (this.CARTS || []).reduce(
            (s, x) => s + Number((x.subtotal ?? x.price_unit ?? 0) * (x.quantity ?? 1)), 0
        );

        this.writeMinimal(minimal);

 
        const hash = JSON.stringify(minimal);
        if (hash === this.lastCartPayloadHash) return;
        this.lastCartPayloadHash = hash;

        clearTimeout(this.cartHydrateTimer);
        this.cartHydrateTimer = setTimeout(async () => {
            await this.hydrateMiniCart(minimal);
            this.refreshFeather();
        }, 120);
    });

    this.emitter.on('save-cart', data => {
        this.addCart(data);
    });

    this.emitter.on('cart-list', () => {
        const MIN = (this.CARTS || []).map(c => ({
            uniqd: String(c.uniqd),
            quantity: Number(c.quantity || 1),
        }));
      
        const src = store.getters.loggedIn ? 'server' : 'header';
        this.emitter.emit('cart-shop', { items: MIN, replace: true, source: src });
        this.emitter.emit('groups_coupons', this.groups_coupons);
    });

   
    this.emitter.on('refres-cart-list', async () => {
        if (!store.getters.loggedIn) return;
        await this.listCarts();
    });

    if (!store.getters.loggedIn) {
        setTimeout(() => {
            const W = this.$cookies.get("wishlist") ? this.$cookies.get("wishlist") : [];
            this.emitter.emit("wish-list-product", W);
        }, 100);
    } else {
        this.listWishList();
    }
    this.emitter.on('wish-list-product', data => { this.WISHLIST = data; });
    this.emitter.on('save-wish-list', data => { this.addWishList(data); });

    this.user = store.state.user;
    this.search_historials = this.$cookies.get("searchlist") ? this.$cookies.get("searchlist") : [];
    let COMPARES = localStorage.getItem("compares") ? JSON.parse(localStorage.getItem("compares")) : [];
    this.COMPARES = COMPARES;
    this.emitter.on("compare-product", (data) => { this.COMPARES = data; });

    if (!document.querySelector('script[src="../../assets/js/myjs/submenu.js"]')) {
        const script56 = document.createElement('script');
        script56.src = '../../assets/js/myjs/submenu.js';
        document.body.appendChild(script56);
    }
},
watch: {
    '$route'() {
        this.limpiarEstadoUI();
         window.dispatchEvent(new Event('resize'));
    }
}



}
</script>

<style>
.shopingbag .onhover-show-div .card-wrap{
    height: auto;
    max-height: 342px !important;
    /* overflow: scroll; */
}
.label{
    color: black;
}
.header-top-header p{
    margin-bottom: 0px !important;
}

#toggleButton{
    display: none;
}
#overMobile{
    display: block;
}
@media screen and (max-width: 575px) {
    #toggleButton{
        display: block;
    }
    #overMobile{
        display: none;
    }
}
@media screen and (max-width: 450px) {
    #toggleButton{
        display: block;
    }
    #overMobile{
        display: none;
    }
}
@media screen and (max-width: 308px) {
    #toggleButton{
        display: block;
    }
    #overMobile{
        display: none;
    }
}
</style>